import React, { useState, useEffect } from "react";
import axios from "axios";

const CampaignCenterMapping = () => {
  const [form, setForm] = useState({
    centerName: "",
    campaignName: "",
    isActive: "",
  });

  const [list, setList] = useState([]);
  const [selected, setSelected] = useState([]);
  const [editId, setEditId] = useState(null);

  // ✅ Fetch all mappings on load
  useEffect(() => {
    fetchMappings();
  }, []);

  const fetchMappings = async () => {
    try {
      const res = await axios.get("https://crm-server-htk6.vercel.app/api/campaignCenterMappings");
      setList(res.data);
    } catch (err) {
      console.error("❌ Error fetching mappings:", err);
    }
  };

  // ✅ Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  // ✅ Save mapping
  const handleSave = async () => {
    if (!form.centerName || !form.campaignName) {
      return alert("⚠️ Please fill all fields");
    }
    try {
      const res = await axios.post("https://crm-server-htk6.vercel.app/api/campaignCenterMappings", form);
      if (res.data.success) {
        alert("✅ Mapping saved successfully");
        fetchMappings();
        resetForm();
      }
    } catch (err) {
      console.error("❌ Error saving mapping:", err);
    }
  };

  // ✅ Edit mapping
  const handleEdit = (row) => {
    setForm({
      centerName: row.centerName,
      campaignName: row.campaignName,
      isActive: row.isActive,
    });
    setEditId(row._id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ Update mapping
  const handleUpdate = async () => {
    if (!form.centerName || !form.campaignName) {
      return alert("⚠️ Please fill all fields");
    }
    try {
      await axios.put(`https://crm-server-htk6.vercel.app/api/campaignCenterMappings/${editId}`, form);
      alert("✨ Mapping updated successfully");
      fetchMappings();
      resetForm();
    } catch (err) {
      console.error("❌ Error updating mapping:", err);
    }
  };

  // ✅ Reset form
  const resetForm = () => {
    setForm({
      centerName: "",
      campaignName: "",
      isActive: "",
    });
    setEditId(null);
  };

  // ✅ Delete mapping
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this mapping?")) return;
    try {
      await axios.delete(`https://crm-server-htk6.vercel.app/api/campaignCenterMappings/${id}`);
      fetchMappings();
      setSelected((prev) => prev.filter((s) => s !== id));
    } catch (err) {
      console.error("❌ Error deleting mapping:", err);
    }
  };

  // ✅ Bulk delete
  const handleBulkDelete = async () => {
    if (selected.length === 0) {
      alert("⚠️ Please select at least one mapping to delete");
      return;
    }
    if (!window.confirm(`Delete ${selected.length} selected mappings?`)) return;

    try {
      await axios.delete("https://crm-server-htk6.vercel.app/api/campaignCenterMappings", {
        data: { ids: selected },
      });
      setSelected([]);
      fetchMappings();
    } catch (err) {
      console.error("❌ Error bulk deleting mappings:", err);
    }
  };

  // ✅ Toggle single selection
  const toggleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );
  };

  // ✅ Select all
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelected(list.map((row) => row._id));
    } else {
      setSelected([]);
    }
  };

const [campaigns, setCampaigns] = useState([]);

  useEffect(() => {
    fetchCampaigns();
  }, []);

  const fetchCampaigns = async () => {
    try {
      const res = await axios.get("https://crm-server-htk6.vercel.app/api/campaigns"); // ✅ full URL
      setCampaigns(res.data); // store campaigns in state
    } catch (err) {
      console.error("❌ Error fetching campaigns:", err);
    }
  };

  const [centers, setCenters] = useState([]);

  // ✅ Fetch centers on component load
  useEffect(() => {
    fetchCenters();
  }, []);

  const fetchCenters = async () => {
    try {
      const res = await axios.get("https://crm-server-htk6.vercel.app/api/centers");
      setCenters(res.data);
    } catch (err) {
      console.error("❌ Error fetching centers:", err);
    }
  };

  return (
    <div className="page" style={{ fontFamily: "Arial, sans-serif", padding: "20px" }}>
      <h2 style={{ textAlign: "center", color: "#2a9d8f" }}>Campaign-Center Mapping</h2>

      {/* Form Section */}
      <div
        className="form-container"
        style={{
          background: "#f8f9fa",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "20px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        }}
      >
        <h3 style={{ marginBottom: "15px", color: "#264653" }}>
          {editId ? "✏️ Update Mapping" : "➕ Add New Mapping"}
        </h3>

        <div className="form-row" style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
         <select
      name="centerName"
      value={form.centerName}
      onChange={handleChange}
      style={{ flex: 2, padding: "8px" }}
    >
      <option value="">Select Center Name</option>
      {centers.map((center) => (
        <option key={center._id} value={center.centerName}>
          {center.centerName}
        </option>
      ))}
    </select>

          <select
      name="campaignName"
      value={form.campaignName}
      onChange={handleChange}
      style={{ flex: 2, padding: "8px" }}
    >
      <option value="">Select Campaign Name</option>
      {campaigns.map((campaign) => (
        <option key={campaign._id} value={campaign.campaignName}>
          {campaign.campaignName}
        </option>
      ))}
    </select>

          <select
            name="isActive"
            value={form.isActive}
            onChange={handleChange}
            style={{ flex: 1, padding: "8px" }}
          >
            <option value="">Select Status</option>
            <option value="Active">Active</option>
            <option value="InActive">InActive</option>
          </select>
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={editId ? handleUpdate : handleSave}
            style={{
              background: editId ? "#e9c46a" : "#2a9d8f",
              color: "white",
              padding: "10px 16px",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              flex: 1,
            }}
          >
            {editId ? "✏️ Update Mapping" : "💾 Save Mapping"}
          </button>

          {editId && (
            <button
              onClick={resetForm}
              style={{
                background: "#e63946",
                color: "white",
                padding: "10px 16px",
                borderRadius: "6px",
                border: "none",
                cursor: "pointer",
                flex: 1,
              }}
            >
              ❌ Cancel
            </button>
          )}
        </div>
      </div>

      {/* Header with Bulk Delete */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <h3 style={{ margin: 0 }}>📋 Mapping List</h3>
        <button
          onClick={handleBulkDelete}
          style={{
            background: selected.length > 0 ? "#e63946" : "gray",
            color: "white",
            padding: "8px 16px",
            borderRadius: "6px",
            border: "none",
            cursor: selected.length > 0 ? "pointer" : "not-allowed",
          }}
          disabled={selected.length === 0}
        >
          🗑 Delete Selected ({selected.length})
        </button>
      </div>

      {/* Table Section */}
      <div className="table-container" style={{ overflowX: "auto" }}>
        <table className="user-table" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ background: "#f4f4f4" }}>
            <tr>
              <th>
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={list.length > 0 && selected.length === list.length}
                />
              </th>
              <th>Center Name</th>
              <th>Campaign Name</th>
              <th>Status</th>
              <th>Log Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: "center", padding: "12px" }}>
                  No records found
                </td>
              </tr>
            ) : (
              list.map((row) => (
                <tr key={row._id} style={{ borderBottom: "1px solid #ddd" }}>
                  <td style={{ textAlign: "center" }}>
                    <input
                      type="checkbox"
                      checked={selected.includes(row._id)}
                      onChange={() => toggleSelect(row._id)}
                    />
                  </td>
                  <td>{row.centerName}</td>
                  <td>{row.campaignName}</td>
                  <td>{row.isActive}</td>
                  <td>{new Date(row.logDate).toLocaleDateString()}</td>
                  <td style={{ textAlign: "center" }}>
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                      <button
                        onClick={() => handleEdit(row)}
                        style={{
                          background: "#457b9d",
                          color: "white",
                          border: "none",
                          padding: "5px 10px",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        ✏️ Edit
                      </button>
                      <button
                        onClick={() => handleDelete(row._id)}
                        style={{
                          background: "#e63946",
                          color: "white",
                          border: "none",
                          padding: "5px 10px",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        🗑 Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CampaignCenterMapping;
